module.exports = __webpack_public_path__ + "img/pla_DY.e84eb70e.png";